import { Backend, getQueryParamValue } from '@shared/datastore/core';
import { BidsGetResultApi } from 'api-typings/projects/projects';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    bids: BidsGetResultApi;
  }
}

export const bidsBackend: Backend<'bids'> = {
  fetch: (_, bidIds, query) => ({
    endpoint: `projects/0.1/bids`,
    params: {
      bids: bidIds || [],
      bidders: query ? getQueryParamValue(query, 'bidderId') : [],
      projects: query ? getQueryParamValue(query, 'projectId') : [],
      frontend_bid_statuses: query
        ? getQueryParamValue(query, 'frontendBidStatus')
        : [],
      award_statuses: query ? getQueryParamValue(query, 'awardStatus') : [],
      complete_statuses: query
        ? getQueryParamValue(query, 'completeStatus')
        : [],
      project_details: 'true',
    },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/bids/bids.backend.ts